import React from 'react'
import { Link } from 'react-router-dom'
import Constant, { getTypeTags } from '../../../Constant'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import axios from 'axios'
import Moment from 'react-moment'
import moment from 'moment'
import Loader from '../../../common/Loader'
import CustomFooter from '../../../common/TableBottom'
import Select from 'react-select'
import Button from '../../../common/CustomComponents/Button'

class ChaletBookingList extends React.Component {
  state = {
    isSearching: false,
    bookingList: [],
    country_list: [],
    chalet_list: [],
    limit: 10,
    pageNumber: 0,
    bookingStatus: '',
    country: '',
    keyword: '',
    chaletId: null,
    type_tag: '',
    disabled: false,
    totalCount: 0,
    totalPages: 0,
  }

  debounceTimeout = null

  componentDidMount() {
    this.getBookingList()
    this.getCountries()
  }

  componentWillUnmount() {
    // Clear timeout on unmount
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout)
    }
  }

  getBookingList = async () => {
    this.setState({
      isSearching: true,
      bookingList: [],
    })

    await axios
      .get(Constant.getAPI() + `/chalet/chalet-booking-list`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
        params: {
          limit: this.state.limit,
          pageNumber: this.state.pageNumber,
          country: this.state.country,
          booking_status: this.state.bookingStatus,
          keyword: this.state.keyword,
          chaletId: this.state.chaletId?.value || '',
          type_tag: this.state.type_tag,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            bookingList: res.data.data,
            disabled: this.state?.pageNumber + 1 >= res?.data?.pagination?.pages,
            totalCount: res.data.pagination?.count || 0,
            totalPages: res.data.pagination?.pages || 0,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isSearching: false,
        })
      })
  }

  getCountries = async () => {
    await axios
      .get(Constant.getAPI() + '/multi-country/list-countries?show_all_countries=true', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name:
            localStorage.getItem('loged_In_role') === 'super-admin'
              ? ''
              : `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          this.setState({
            country_list: res.data.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getChaletList = async () => {
    await axios
      .get(Constant.getAPI() + '/chalet/list-chalet', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: this.state.country,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          this.setState({
            chalet_list: res?.data?.data?.map((itm) => ({
              label: `${itm.name_en}/${itm.name_ar}`,
              value: itm.id,
            })),
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleChange = (event) => {
    event.persist()
    const fieldName = event?.target?.name
    const fieldValue = event?.target?.value

    this.setState(
      {
        [fieldName]: fieldValue,
      },
      () => {
        if (fieldName == 'country') {
          this.setState(
            {
              chalet_list: [],
              chaletId: '',
            },
            () => {
              if (event.target.value != '') {
                this.getChaletList()
              }
            }
          )
        }

        // Auto-search with debounce for all filters except keyword
        if (fieldName !== 'keyword') {
          this.triggerAutoSearch()
        } else {
          // Debounce keyword search
          this.triggerDebouncedSearch()
        }
      }
    )
  }

  changeBookingTagAndStatus = async (event, rowData) => {
    let data = {}

    let id = rowData[0]
    let temp_data = this.state.bookingList
    temp_data.forEach((itm) => {
      if (itm.order_number == id) {
        itm[event.target.name] = event.target.value

        data.booking_id = itm.id
        data[event.target.name] = event.target.value
      }
    })

    this.setState({
      bookingList: temp_data,
    })

    const checkIfPaydoStore = this.state.bookingList
      ?.find((ele) => ele.id === data?.booking_id)
      ?.additional_items?.find((ele) => ele.store_item?.store?.is_paydo_store)

    if (checkIfPaydoStore && data.booking_status === 'Cancelled') {
      const result = await Swal.fire({
        title: 'Alert!',
        text: 'Before changing status to cancel, Make sure to cancel order at Paydo',
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `No`,
      })

      if (result.isConfirmed) {
        await this.updateStatus(data)
      }
      if (result.isDismissed) {
        this.getBookingList()
      }
    } else {
      await this.updateStatus(data)
    }
  }

  updateStatus = async (data) => {
    await axios
      .post(Constant?.getAPI() + `/chalet/change-booking-details`, data, {
        headers: {
          Authorization: `Bearer ${localStorage?.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          Swal.fire({
            toast: true,
            icon: 'success',
            position: 'top-end',
            title: `Updated`,
            text: 'Cruise details Updated',
            showConfirmButton: false,
            timerProgressBar: true,
            timer: 2500,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  searchData = async () => {
    this.getBookingList()
  }

  clearFilters = () => {
    // Clear any pending debounce
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout)
    }

    this.setState(
      {
        limit: 10,
        pageNumber: 0,

        bookingStatus: '',
        country: '',
        keyword: '',
        chaletId: '',
        type_tag: '',

        bookingList: [],
      },
      () => {
        // Auto-fetch data after clearing filters
        this.getBookingList()
      }
    )
  }

  triggerDebouncedSearch = () => {
    // Clear existing timeout
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout)
    }

    // Set new timeout for keyword search (500ms delay)
    this.debounceTimeout = setTimeout(() => {
      this.setState(
        {
          pageNumber: 0,
        },
        () => {
          this.getBookingList()
        }
      )
    }, 500)
  }

  triggerAutoSearch = () => {
    // Clear existing timeout
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout)
    }

    // Set new timeout for filter changes (300ms delay)
    this.debounceTimeout = setTimeout(() => {
      this.setState(
        {
          pageNumber: 0,
        },
        () => {
          this.getBookingList()
        }
      )
    }, 300)
  }

  handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      this.searchData()
    }
  }

  handleClear = () => {
    this.setState({ chaletId: null })
  }

  handleChaletChange = (event) => {
    this.setState({
      chaletId: event,
    })
    // Auto-search when chalet changes
    this.triggerAutoSearch()
  }

  render() {
    const columns = [
      {
        name: 'order_number',
        label: 'Order NO',
        options: {
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'customer_phone',
        label: 'Customer Phone',
        options: {
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'chalet_name',
        label: 'Chalet Name',
        options: {
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'start_date',
        label: 'Booking Start Date',
        options: {
          customBodyRender: (value) =>
            value ? (
              <div style={{ textWrap: 'nowrap' }}>{moment(value, 'YYYY-MM-DD').format('DD MMM YYYY')}</div>
            ) : (
              '--'
            ),
        },
      },
      {
        name: 'end_date',
        label: 'Booking End Date',
        options: {
          customBodyRender: (value) =>
            value ? (
              <div style={{ textWrap: 'nowrap' }}>{moment(value, 'YYYY-MM-DD').format('DD MMM YYYY')}</div>
            ) : (
              '--'
            ),
        },
      },
      {
        name: 'created_at',
        label: 'Issue Date',
        options: {
          customBodyRender: (value) =>
            value ? (
              <div style={{ textWrap: 'nowrap' }}>
                <Moment format="DD MMM YYYY">{value}</Moment>
              </div>
            ) : (
              '--'
            ),
        },
      },
      {
        name: 'total_booking_amount',
        label: 'Total Booking Amount',
      },
      {
        name: 'wallet_amount_applied',
        label: 'Wallet Applied Amount',
      },
      {
        name: 'coupon_applied_amount',
        label: 'Coupon Applied Amount',
      },
      {
        name: 'coupon_code',
        label: 'Coupon Code',
        options: {
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'payment_status',
        label: 'Payment status',
        options: {
          customBodyRender: (payment_status) => {
            return (
              <div>
                {payment_status === true ? (
                  <span className="badge badge-pill badge-success">Success</span>
                ) : (
                  <span className="badge badge-pill badge-warning">Pending</span>
                )}
              </div>
            )
          },
        },
      },
      {
        name: 'payment_method',
        label: 'Payment Method',
        options: {
          customBodyRender: (value) => {
            return value && value.length > 0 ? value.join('\n') : '--'
          },
        },
      },
      {
        name: 'country',
        label: 'Country',
        options: {
          display: this.state.country == '',
        },
      },
      {
        name: 'booking_status',
        label: 'Booking Status',
        options: {
          customBodyRender: (value, { rowData }) => {
            return (
              <>
                <select
                  style={{ minWidth: 150 }}
                  name="booking_status"
                  className={`form-control`}
                  value={value}
                  onChange={(event) => this.changeBookingTagAndStatus(event, rowData)}
                >
                  <option value={''}>N/A</option>
                  <option value="Pending">Pending</option>
                  <option value="Confirmed">Confirmed</option>
                  <option value="Successful">Successful</option>
                  <option value="Postponed">Postponed</option>
                  <option value="Cancelled">Cancelled</option>
                </select>
              </>
            )
          },
        },
      },
      {
        name: 'type_tag',
        label: 'Type Tag',
        options: {
          customBodyRender: (value, { rowData }) => {
            return (
              <>
                <select
                  style={{ minWidth: 150 }}
                  name="type_tag"
                  className="form-control"
                  value={value}
                  onChange={(event) => this.changeBookingTagAndStatus(event, rowData)}
                >
                  <option value={''}>N/A</option>
                  {getTypeTags().map((itm) => (
                    <option
                      value={itm}
                      key={itm}
                    >
                      {itm}
                    </option>
                  ))}
                </select>
              </>
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Action',
        options: {
          customBodyRender: (booking_id) => {
            return (
              <div>
                <Link
                  to={'/chalet-booking-details/' + booking_id}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="View "
                >
                  <i className="f-22 icofont icofont-eye text-dark"></i>
                </Link>
              </div>
            )
          },
        },
      },
    ]

    const options = {
      viewColumns: false,
      print: false,
      download: false,
      search: false,
      filter: false,
      count: this.state.totalCount,
      page: this.state.pageNumber,
      rowsPerPage: this.state.limit,
      // setRowProps: (row) => {
      //   let basketData = getBasketSizeLimits(row[11], 'ch')
      //   if (row[5] + row[6] + row[7] > basketData.max) {
      //     return {
      //       style: { background: basketData.maxColor },
      //     }
      //   } else if (row[5] + row[6] + row[7] < basketData.min) {
      //     return {
      //       style: { background: basketData.minColor },
      //     }
      //   }
      // },
      customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage) => {
        return (
          <CustomFooter
            changePage={changePage}
            changeRowsPerPage={changeRowsPerPage}
            disabled={this.state.disabled}
            count={this.state.limit}
            pageNumber={this.state.pageNumber}
            totalPages={this.state.totalPages}
          />
        )
      },
      onChangePage: (currentPage) => {
        this.setState(
          {
            pageNumber: currentPage,
          },
          () => this.getBookingList()
        )
      },
      onChangeRowsPerPage: (numberOfRows) => {
        this.setState(
          {
            limit: numberOfRows,
            pageNumber: 0,
          },
          () => this.getBookingList()
        )
      },

      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isSearching ? <Loader open={this.state.isSearching} /> : 'Sorry, No Booking Data Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <>
        <div className="page-body">
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-border-default">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Search</label>
                        <div className="col-sm-9">
                          <input
                            type="text"
                            id="keyword"
                            className="form-control"
                            value={this.state.keyword}
                            name="keyword"
                            placeholder="Order No | Customer Phone/Email | Order Reference Id"
                            onKeyPress={this.handleKeyPress}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className="col-12"
                      style={{ borderBottom: '2px solid #ddd', marginBottom: 16 }}
                    ></div>
                    <div className="col-md-4">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Booking Status</label>
                        <div className="col-sm-9">
                          <select
                            name="bookingStatus"
                            className="form-control"
                            value={this.state.bookingStatus}
                            onChange={this.handleChange}
                          >
                            <option value={''}>All</option>
                            <option value={'Pending'}>Pending</option>
                            <option value={'Successful'}>Successful</option>
                            <option value={'Cancelled'}>Cancelled</option>
                            <option value={'Confirmed'}>Confirmed</option>
                            <option value="Postponed">Postponed</option>
                            <option value={'Incomplete'}>Incomplete</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Country</label>
                        <div className="col-sm-9">
                          <select
                            name="country"
                            className="form-control"
                            value={this.state.country}
                            onChange={this.handleChange}
                          >
                            <option value={''}>All</option>
                            {this.state.country_list.map((country) => (
                              <option
                                value={country.country_short_name}
                                key={country.country_short_name}
                              >
                                {country.country_name_en + '/' + country.country_name_ar}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Chalet</label>
                        <div className="col-sm-9">
                          <Select
                            name="chaletId"
                            value={this.state.chaletId}
                            onChange={this.handleChaletChange}
                            options={this.state.chalet_list}
                            isMulti={false}
                            isSearchable={true}
                            isClearable
                            onClear={this.handleClear}
                            placeholder="Select Options"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Type Tag</label>
                        <div className="col-sm-9">
                          <select
                            name="type_tag"
                            className="form-control"
                            value={this.state.type_tag}
                            onChange={this.handleChange}
                          >
                            <option value={''}>All</option>
                            {getTypeTags().map((itm) => (
                              <option
                                value={itm}
                                key={itm}
                              >
                                {itm}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group row">
                        <div className="col-12">
                          <Button
                            disabled={this.state.isSearching}
                            onClick={this.searchData}
                          >
                            {this.state.isSearching ? 'Searching...!' : 'Search'}
                          </Button>
                          <Button
                            disabled={this.state.isSearching}
                            onClick={this.clearFilters}
                            variant="outlined"
                          >
                            clear
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="page-body">
          <div className="row">
            <div className="col-sm-12">
              <div className="dt-responsive table-responsive">
                <MUIDataTable
                  className="table-responsive"
                  data={this.state.bookingList}
                  columns={columns}
                  options={options}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default ChaletBookingList
